<div class="form-group row">
    <label class="col-md-2 col-form-label">Client</label>
    <div class="col-md-10">
        <select class="form-control" [(ngModel)]="selectedClient" (change)="onClientChange()">
            <option [ngValue]="undefined" selected>Please Select a Client</option>
            <option *ngFor="let client of availableClientList" [ngValue]="client">{{client.clientName}}</option>
        </select>
    </div>
</div>
<div class="form-group row">
    <label class="col-md-2 col-form-label">DNA</label>
    <div class="col-md-10">
        <select class="form-control" [disabled]="!selectedClient" [(ngModel)]="selectedDna" (change)="onDnaChange()">
            <option [ngValue]="undefined" selected>Please Select a DNA</option>
            <option *ngFor="let dna of availableDnaList" [ngValue]="dna">{{dna.dnaName}}</option>
        </select>
    </div>
</div>
